const MENU_ICON_ID_PREFIX = `dots-icon-`;
const DESKTOP_OFFSET_Y = 80;
const MOBILE_OFFSET_Y = 150;
const OFFSET_PROMO = 70;

/**
 * calculate position of the context menu below the menu icon
 */

function calcContextMenuTopPosition(
  menuItemIndex: number,
  offsetY: number | undefined,
  desktopCondition: boolean,
  withPromo: boolean
) {
  const menuIconElement = document.getElementById(
    `${MENU_ICON_ID_PREFIX}${menuItemIndex}`
  );

  if (menuIconElement) {
    const menuIconTopValue = menuIconElement.getBoundingClientRect().top;
    const bodyScrollTop = document.body.getBoundingClientRect().top;
    const offset =
      offsetY || (desktopCondition ? DESKTOP_OFFSET_Y : MOBILE_OFFSET_Y);

    const calculatedTopPosition =
      menuIconTopValue -
      bodyScrollTop -
      offset -
      (withPromo ? OFFSET_PROMO : 0);

    return calculatedTopPosition;
  } else {
    return 0;
  }
}

export default calcContextMenuTopPosition;
